import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DownloadedFile } from '../../../lib/util/downloaded-files';
import { LegacyProcessService } from '../../../lib/legacy-process/legacy-process.service';
import { saveAs } from 'file-saver';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UiConstants } from '../../../util/core-utils';

@Component({
  selector: 'app-legacy-process-mpl-export-dialog',
  templateUrl: './legacy-process-mpl-export-dialog.component.html',
  styleUrls: ['./legacy-process-mpl-export-dialog.component.scss']
})
export class LegacyProcessMplExportDialogComponent implements OnInit {
  UiConstants = UiConstants;

  @ViewChild('dialog', { static: true })
  dialog: ModalDirective;
  dialogVisible: boolean = false;

  @Input()
  processId: number;

  downloading: boolean = false;

  groupByIdenticalItems: boolean = true;

  constructor(private processService: LegacyProcessService) {
  }

  ngOnInit() {
  }

  mplExport() {
    this.downloading = true;
    this.processService.mplExport({
      processId: this.processId,
      groupByIdenticalItems: this.groupByIdenticalItems
    }).subscribe(
      (res: DownloadedFile) => {
        saveAs(res.getBlob(), res.getFileName('mpl_export.csv'));
        this.closeDialog();
        this.downloading = false;
      }, error => {
        this.downloading = false;
      },
    );
  }

  showDialog() {
    this.dialogVisible = true;
    this.dialog.show();
  }

  closeDialog() {
    this.dialogVisible = false;
    this.dialog.hide();
    this.groupByIdenticalItems = true;
  }

}
